/**
 * Pairs a bundle-option radio (sections/main-product-hero.liquid, .vr-opt__radio)
 * with a subscription "gift" product when the option carries data-gift-variant-id /
 * data-gift-selling-plan-id. The gift line is added as a second /cart/add.js call
 * right after the shopper's own add succeeds, so it always lands as its own cart line
 * with its own selling plan instead of being folded into the main item's price.
 *
 * The pairing is recorded in localStorage for assets/a-rebuy-gift-sync.js to act on
 * once the host variant leaves the cart. It deliberately lives outside the cart:
 * Rebuy rebuilds the subscription line (new key, empty properties), so anything
 * stored on the cart itself — line properties, cart attributes — gets wiped.
 * The `_gift_for_variant_id` property is still sent as a best-effort hint.
 */
(function () {
  if (window.__vrGiftPairingBound) return;
  window.__vrGiftPairingBound = true;

  function currentGiftOffer() {
    var checked = document.querySelector('.vr-opt__radio:checked[data-gift-variant-id][data-gift-selling-plan-id]');
    if (!checked) return null;
    return {
      hostVariantId: checked.value,
      giftVariantId: checked.getAttribute('data-gift-variant-id'),
      sellingPlanId: checked.getAttribute('data-gift-selling-plan-id'),
    };
  }

  function bodyMatchesVariant(body, variantId) {
    if (!body) return false;
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return String(body.get('id')) === String(variantId);
      }
      var text = typeof body === 'string' ? body : JSON.stringify(body);
      return text.indexOf('"id":' + variantId) !== -1 || text.indexOf('id=' + variantId) !== -1;
    } catch (e) {
      return false;
    }
  }

  function recordPair(offer) {
    try {
      var pairs = JSON.parse(localStorage.getItem('vr_gift_pairs') || '{}');
      pairs[offer.giftVariantId] = offer.hostVariantId;
      localStorage.setItem('vr_gift_pairs', JSON.stringify(pairs));
    } catch (e) {}
  }

  function addGift(offer) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(offer.giftVariantId),
          quantity: 1,
          selling_plan: Number(offer.sellingPlanId),
          properties: { _gift_for_variant_id: offer.hostVariantId },
        }],
      }),
    }).then(function () {
      recordPair(offer);
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    });
  }

  var originalFetch = window.fetch;
  window.fetch = function (...args) {
    var url = args[0];
    var isAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    var offer = isAdd ? currentGiftOffer() : null;
    var promise = originalFetch.apply(this, args);
    if (isAdd && offer && bodyMatchesVariant(args[1] && args[1].body, offer.hostVariantId)) {
      promise = promise.then(function (response) {
        if (response.ok) addGift(offer);
        return response;
      });
    }
    return promise;
  };
})();
